import React from 'react';
import ProgressiveImage from 'react-progressive-graceful-image';

import OnboardingPicture from './OnboardingPicture.jpeg';

const Picture: React.FC = () => {
  return (
    <ProgressiveImage src={OnboardingPicture} placeholder={OnboardingPicture}>
      {(src: any): any => (
        <img src={src} alt="Onboarding Picture" height="498px" width="500px" />
      )}
    </ProgressiveImage>
  );
};

export default Picture;
